/**
 * <pre>
 * Api service.
 *
 * Summary of responsibilities:
 *
 *  - provides abstraction layer for working with the Api.
 * </pre>
 *
 * @author Various
 * @namespace Common.Services.ApiService
 */
const ApiService = (function() {

	'use strict';

	// The legacy Api.
	var _legacyApi;

	// - - - - - - - - - - - - - - - - - - - - - - - - - - - - - -
	/**
	 * Init.
	 *
	 * @memberOf Common.Services.ApiService
	 *
	 * @param legacyApi 	{object} Refefence to the legacy NGX app Api object.
	 */
	const init = (legacyApi) => {

		// Store injected properties.
		_legacyApi = legacyApi;
	};

	// - - - - - - - - - - - - - - - - - - - - - - - - - - - - - -
	// Api Methods.

	/**
	 * Execute an api method.
	 *
	 * @memberOf Common.Services.ApiService
	 *
	 * @param method {string} Api method name.
	 */
	const execute = function(method) {

		// If an Api method with matching name exists.
		if(_legacyApi[method]) {

			// Remove the first element from the arguments.
			Array.prototype.shift.apply(arguments);

			// Execute it and pass the arguments.
			return _legacyApi[method].apply(_legacyApi, arguments);
		}
	};

	// Expose scoped properties.
	return {

		init: 	init,

		execute: execute
	}

}());

export default ApiService;